const time_jump = 5000;
// Handles Components Actions
export default {
  methods: {
    doAction(payload) {
      // Executes the action in the action attribute using the given payload as a unique parameter
      this[this.attributes.action](payload);
    },
    i18n(data) {
      this.$store.commit("i18n", data);
    },
    start() {
      // play param action for fix param playing et not change if input changes
      this.$store.commit("playParam");
      // Start player action
      this.$store.commit("startPlayer");
    },
    stop() {
      if (this.$store.getters.player.started !== 0) {
        this.$store.commit("stopPlayer");
      }
      // Stop player action
    },
    replay() {
      // Replay player action
      if (this.$store.getters.player.started !== 0) {
        this.$store.commit("stopPlayer");
      }
      // play param action for fix param playing et not change if input changes
      this.$store.commit("playParam");
      this.$store.commit("startPlayer");
    },
    pause() {
      // pause player action
      if (this.$store.getters.finish < 1) {
        this.$store.commit("pausePlayer");
      }
    },
    un_pause() {
      // unpause player action
      this.$store.commit("unPausePlayer");
    },
    speed_1() {
      //retourne à la vitesse de lecture initiale
      this.$store.commit("speedPlayer", 1);
    },
    speed_2() {
      //il mets la vitesse de lecture à x2
      this.$store.commit("speedPlayer", 2);
    },
    speed_10() {
      //il mets la vitesse de lecture à x10
      this.$store.commit("speedPlayer", 10);
    },
    back() {
      //on revient en arriere
      this.$store.getters.progress < time_jump
        ? this.$store.commit("backPlayer", this.$store.getters.progress)
        : this.$store.commit("backPlayer", time_jump);
    },
    forward() {
      //on avance
      this.$store.commit("forwardPlayer", time_jump);
    },
    endpoint(time) {
      // on va à un point donné du player ( chapitrage)
      this.$store.commit("endpointPlayer", time);
    },
    open_result(url) {
      var res = url;
      var url_interpolate = res.interpolate(this);
      res.interpolate(this).includes(undefined)
        ? (url_interpolate = "")
        : (url_interpolate = url_interpolate);
      window.open(`${url_interpolate}`, "_blank");
    },
    confirm_exit() {
      this.$store.commit("stopPlayer");
      this.$bvModal.show("testmodal");
    },
    open_result_video(url) {
      let params = {
        params: this.$store.getters.testParams,
        id_result: this.attributes.action_parameter,
        start: 0,
        end: 0,
        flux_identifier: "",
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      var result = this.getObjectList(
        "observation_data/open_result",
        params
      ).then((data) => {
        return data;
      });
      result.then((result) => {
        this.open_result(result);
      });
    },
    export_data() {
      let params = {
        params: this.$store.getters.testParams,
        start: 0,
        end: 0,
        flux_identifier: "",
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };

      this.getObjectList("observation_data/export_data", params).then(
        (data) => {
          let tab = Object.values(data);
          let csvContent = "data:text/csv;charset=utf-8,";
          csvContent += [
            Object.values("").join(";"),
            ...tab.map((item) => Object.values(item).join(";")),
          ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

          const datas = encodeURI(csvContent);

          // test for safari: https://github.com/mholt/PapaParse/issues/175
          var blob = new Blob([csvContent]);
          if (window.navigator.msSaveOrOpenBlob)
            // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.open(datas);
          //window.navigator.msSaveBlob(blob, `${this.$store.getters.testParams}_${Date.now()}.csv`);
          else {
            var a = window.document.createElement("a");
            a.href = window.URL.createObjectURL(blob, { type: "text/plain" });
            a.download = `${
              this.$store.getters.experienceIdentifier
            }_${Date.now()}.csv`;
            document.body.appendChild(a);
            a.click(); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(a);
          }
          //

          return data;
        }
      );
    },
    export_data_file(flux_identifier) {
      let params = {
        params: this.$store.getters.testParams,
        start: 0,
        end: 0,
        flux_identifier: flux_identifier,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      this.getObjectFile("observation_data/export_data_file", params);
    },
  },
};
